import type { ReactNode } from "react"
import { AppAuthProvider } from "@/hooks/useAppAuth"
import { WebBalanceProvider } from "@/hooks/useWebBalance"

export function AppProviders({ children }: { children: ReactNode }) {
	return (
		<AppAuthProvider>
			<WebBalanceProvider>{children}</WebBalanceProvider>
		</AppAuthProvider>
	)
}
